import { Zap } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { GlobalSettings } from "@/components/GlobalSettings";

export const TopBar = ({ title, right, testid = "top-bar" }) => {
  const navigate = useNavigate();
  return (
    <header
      data-testid={testid}
      className="fixed top-0 left-0 right-0 z-40 h-14 bg-[#0B0F17]/85 backdrop-blur-xl border-b border-white/10 px-4 flex items-center justify-between"
    >
      <button
        onClick={() => navigate("/feed")}
        data-testid="top-bar-logo"
        className="flex items-center gap-2"
      >
        <span className="w-8 h-8 rounded-lg bg-gradient-to-br from-rose-500 to-amber-500 flex items-center justify-center shadow-lg shadow-rose-500/30">
          <Zap size={18} className="text-white" strokeWidth={2.8} fill="white" />
        </span>
        <span className="font-display font-black text-base tracking-tight">
          {title || "LastMinute"}
          <span className="text-rose-400">.</span>
        </span>
      </button>
      <div className="flex items-center gap-2"><GlobalSettings />{right}</div>
    </header>
  );
};
